export default class JsonSchemaValidationError extends Error {
    public validationErrorText: string;

    constructor(validationErrorText: string) {
        super(validationErrorText);
        this.validationErrorText = validationErrorText;
    }
}
